// --- 反馈管理 --- //

export default [
  {
    name: 'feedbackList',
    path: '/platformManagement/feedbackManagement/feedbackList',
    meta: { title: '反馈列表' },
    component: require('business/platformManagement/feedbackManagement/feedbackList/list.vue').default
  },
  {
    name: 'feedbackDetail',
    path: '/platformManagement/feedbackManagement/feedbackDetail',
    meta: { title: '反馈详情' },
    component: require('business/platformManagement/feedbackManagement/feedbackList/detail.vue').default
  }
]
